import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { PortfolioInformationAccordion } from './portfolioInformationAccordion';
import { RentalPortfolioStore } from '../../stores/rentalPortfolioStore';
import { PortfolioInformationFormStore } from 'libs/feature-one-tool/src/quote/stores/portfolioInformation/portfolioInformationFormStore';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';
import { OneToolCardBorder } from '../fixFlip/oneToolCard';
import { RentalPortfolioInformationFormStore } from '../../stores/rentalPortfolio/rentalPortfolioInformationFormStore';


interface PropertyInformationCardProps {
  store: RentalPortfolioStore;
  portfolioFormStore: RentalPortfolioInformationFormStore;
}

export const PortfolioInformationCard = observer(
  ({
    portfolioFormStore,
  }: PropertyInformationCardProps) => {

    const [expanded, setExpanded] = useState(false);

    return (
      <OneToolCardBorder>
        <PortfolioInformationAccordion
          store={portfolioFormStore}
          propertyTypes={portfolioFormStore.rentalPortfoliosPropertyTypesAsString}
          expanded={expanded}
          onExpand={expanded => setExpanded(expanded)}
        />
      </OneToolCardBorder>
    );
  }
);
